import * as React from 'react';
import { Spinner as SpinnerIcon } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as styles from './Spinner.css';

export interface ISpinnerProps {
  size?: number;
}

export function Spinner({ size }: ISpinnerProps) {
  return (
    <div {...mergeStyles(styles['container'], { height: size, width: size })}>
      <SpinnerIcon colorType="inverted" size={size} />
    </div>
  );
}
